const numberWithCommas = (number) => {
    if (typeof (number) !== "undefined" && number !== null) {
        var parts = number.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    } else {
        return ""
    }
};
export default numberWithCommas;